import React from "react";
import {MTPLVehicleTypeButton} from "./MtplVehicleTypeButton";
import vt_b from "../../../../../images/vehicle-types/vt_b.svg";
import vt_b_hov from "../../../../../images/vehicle-types/hover/vt_b_hov.svg";
import vt_b5 from "../../../../../images/vehicle-types/vt_b5.svg";
import vt_b5_hov from "../../../../../images/vehicle-types/hover/vt_b5_hov.svg"
import vt_c from "../../../../../images/vehicle-types/vt_c.svg";
import vt_c_hov from "../../../../../images/vehicle-types/hover/vt_c_hov.svg";
import vt_d from "../../../../../images/vehicle-types/vt_d.svg";
import vt_d_hov from "../../../../../images/vehicle-types/hover/vt_d_hov.svg";
import vt_a from "../../../../../images/vehicle-types/vt_a.svg";
import vt_a_hov from "../../../../../images/vehicle-types/hover/vt_a_hov.svg";
import vt_e from "../../../../../images/vehicle-types/vt_e.svg";
import vt_e_hov from "../../../../../images/vehicle-types/hover/vt_e_hov.svg";
import "./MtplVehicleTypeSelectionViewStyles.scss";
import {VehicleGroup} from "../../../../../model/vehicle";
import {MTPLTarifficationDescription} from "../MtplTarifficationDescription";
import {strings} from "../../../../../strings/strings";
import {getSnippetByName} from "../../../../../api/snippetApiClient";
import {WIDGET_DURATION, WidgetTooltip} from "../../../../../App";
import {ChatWidget} from "../../../../../model/chatWidget";
import { useHotjar } from "../../../../../utils/hooks/useHotjar";

interface MTPLVehicleTypeSelectionView {
    onVehicleTypesSelect: (vehicleGroup: VehicleGroup) => void;
}

export const MTPLVehicleTypeSelectionView = ({onVehicleTypesSelect}: MTPLVehicleTypeSelectionView) => {

    const { trackHotjar } = useHotjar()

    React.useEffect(() => {
        let timout: NodeJS.Timeout
        getSnippetByName(ChatWidget.TEMPLATE_HINT_HELLO).then(res => {
            timout = setTimeout(() => {
                WidgetTooltip?.open(res.text, WIDGET_DURATION)
            }, 500)
        })

        trackHotjar("select", "mtpl")

        return () => {
            clearTimeout(timout)
            WidgetTooltip?.close()
        }
    }, [])

    return (
        <div className={"step-view vehicle-type-selection"}>
            <div className={"vehicle-type-selection__selection"}>
                <div className={"vehicle-type-selection__selection__header"}>
                    <span>{strings.vehicleTypeChoose}</span>
                </div>

                <div className="vehicle-type-selection__selection__buttons">
                    <MTPLVehicleTypeButton id={'vehicleShortGroupB_vt_b'} title={strings.vehicleShortGroupB} image={vt_b} altImage={vt_b_hov}
                                           onClick={() => {
                                               onVehicleTypesSelect(VehicleGroup.B)
                                           }}/>
                    <MTPLVehicleTypeButton id={'vehicleShortGroupB_vt_b5'} title={strings.vehicleShortGroupB5} image={vt_b5} altImage={vt_b5_hov}
                                           onClick={() => {
                                               onVehicleTypesSelect(VehicleGroup.B5)
                                           }}/>
                    <MTPLVehicleTypeButton id={'vehicleShortGroupB_vt_c'} title={strings.vehicleShortGroupC} image={vt_c} altImage={vt_c_hov}
                                           onClick={() => {
                                               onVehicleTypesSelect(VehicleGroup.C)
                                           }}/>
                    <MTPLVehicleTypeButton id={'vehicleShortGroupB_vt_d'} title={strings.vehicleGroupD} image={vt_d} altImage={vt_d_hov}
                                           onClick={() => {
                                               onVehicleTypesSelect(VehicleGroup.D)
                                           }}/>
                    <MTPLVehicleTypeButton id={'vehicleShortGroupB_vt_a'} title={strings.vehicleGroupA} image={vt_a} altImage={vt_a_hov}
                                           onClick={() => {
                                               onVehicleTypesSelect(VehicleGroup.A)
                                           }}/>
                    <MTPLVehicleTypeButton id={'vehicleShortGroupB_vt_e'} title={strings.vehicleGroupE} image={vt_e} altImage={vt_e_hov}
                                           onClick={() => {
                                               onVehicleTypesSelect(VehicleGroup.E)
                                           }}/>
                </div>
            </div>
            <div/>
            <div className={"vehicle-type-selection__description"}>
                <MTPLTarifficationDescription/>
            </div>
        </div>
    );
};